module.exports = __webpack_public_path__ + "static/assets/e5c00568f2ed060e0858011803255d04.svg";